<script>
    import TitlePortfolio from "../atoms/TitlePortfolio.svelte";
    import AllSubAccueilPortfolio from "./AllSubAccueilPortfolio.svelte";
    export let subPortfolio;
</script>

{#each subPortfolio as elem}
    <section>
        {#if elem.media.length > 0}
            <TitlePortfolio title="{elem.nom}" />
            <AllSubAccueilPortfolio media = {elem.media}/>
        {/if}
    </section>
{/each}